var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar"},[_c('EncartLaFormation'),_vm._v(" "),_c('EncartVotreFormation'),_vm._v(" "),(false)?_c('EncartFacebook'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/sidebar/Sidebar.vue